import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";

export const DangerZone = ({ customer, customerId, ordersCount, onDeleted }) => {
  const deleteCustomer = async () => {
    try {
      await api.delete(`/customers/${customerId}`);
      toast.success("Customer removed.");
      onDeleted();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <Card className="shadow-sm border-destructive/30">
      <CardHeader className="pb-3"><CardTitle className="font-serif text-xl text-destructive">Careful zone</CardTitle></CardHeader>
      <CardContent>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button variant="destructive" size="sm" data-testid="delete-customer-btn"><Trash2 className="h-4 w-4 mr-2" /> Delete this customer</Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle className="font-serif">Delete {customer.first_name} {customer.last_name}?</AlertDialogTitle>
              <AlertDialogDescription>
                This removes the customer and all {ordersCount} of their orders permanently. This cannot be undone.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel data-testid="cancel-delete-btn">Keep the record</AlertDialogCancel>
              <AlertDialogAction onClick={deleteCustomer} className="bg-destructive hover:bg-destructive/90" data-testid="confirm-delete-btn">Yes, delete everything</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </CardContent>
    </Card>
  );
};
